import { stringify, parse } from 'yaml';

/**
 * Converts JSON to YAML.
 * @param {Object} jsonData - The JSON object to convert.
 * @returns {string} - The YAML string.
 * @throws {Error} - Throws an error if conversion fails.
 */
export const convertJsonToYaml = (jsonData) => {
  try {
    return stringify(jsonData);
  } catch (error) {
    console.error('Error converting JSON to YAML:', error);
    throw new Error('Failed to convert JSON to YAML');
  }
};

/**
 * Converts YAML to JSON.
 * @param {string} yamlString - The YAML string to convert.
 * @returns {Object} - The JSON object.
 * @throws {Error} - Throws an error if conversion fails.
 */
export const convertYamlToJson = (yamlString) => {
  try {
    return parse(yamlString);
  } catch (error) {
    console.error('Error converting YAML to JSON:', error);
    throw new Error('Failed to convert YAML to JSON');
  }
};
